import { useQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'aiCampaign/draft';

export function useAICampaignDraft({ campaignId }: { campaignId?: string }) {
	const userSession = useUserSession();
	return useQuery({
		enabled: !!campaignId,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<Api.ICampaign>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `AICampaign/${encodeURIComponent(campaignId)}` }),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, campaignId],
		meta: {
			toastErrorMessage: 'Failed to load this campaign',
		},
	});
}

export const invalidateAICampaignDraft = (campaignId: string) => {
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, campaignId] });
};

export const setAICampaignDraft = (campaign: Api.ICampaign) => {
	reactQueryClient.setQueryData([BASE_QUERY_KEY, campaign.id], campaign);
};
